import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

interface useBrowserHistory {
  historyStacks: string[];
}

/**
 * 用於追蹤瀏覽器歷史紀錄。
 * 監聽 history 事件，當 location 更動時將新的路徑名稱加入紀錄陣列。
 *
 * @returns 歷史紀錄堆疊，包含了瀏覽器中已訪問的路徑名稱。
 */
export default function useBrowserHistory(): useBrowserHistory {
  /* Global & Local State */
  const history = useHistory();
  const [historyStacks, setHistoryStacks] = useState<string[]>([]);
  /* Functions */
  const updateRouteStack = (pathName: string): void => {
    setHistoryStacks(historyStacks => [pathName, ...historyStacks]);
  };
  /* Hooks */
  useEffect(() => {
    const unListenCallback = history.listen(historyLocation => {
      updateRouteStack(`${historyLocation.pathname}${historyLocation.search}`);
    });
    return () => {
      if (unListenCallback) {
        unListenCallback();
      }
    };
  }, []);
  /* Main */
  return useMemo(
    () => ({
      historyStacks
    }),
    [historyStacks]
  );
}
